import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Person2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"person_2"}/>
}
